import type {RouteLocationNormalizedGeneric} from 'vue-router';
import useAuth from '@/composables/useAuth';

export const authGuard = async (to: RouteLocationNormalizedGeneric) => {
  const {auth0} = useAuth();

  if (auth0.isAuthenticated.value) {
    return true;
  }

  localStorage.setItem('redirect_to', to.fullPath);
  const url = await auth0.buildAuthorizeUrl();
  window.location.replace(url);
  return false;
};
